// The unit a Book-by-Dish `count` is expressed in on the wire. Mirrors the backend enum.
// Only BREAD dishes have two possible units — curry and beverage `count` means people
// either way. The backend treats an absent unit as PIECE, which keeps old app builds
// pricing exactly as they do today.
export enum BookByDishCountUnit {
    PIECE = "PIECE",
    PLATE = "PLATE",
}
